import {
  Events
} from 'ionic-angular/util/events';
import {
  MapService
} from "../../utils/map.service";
import {
  GlobalService
} from './../../providers/global.config';
import {
  GeocodingService
} from './../../utils/geocoding.service';
import {
  DataManagementService
} from './../../providers/data-management.service';
import {
  RealTimeRecord,
  Vehicule
} from './../../objects/real-time';
import {
  Component,
  ViewChild
} from '@angular/core';
import {
  NavController,
  NavParams,
  ToastController,
  ModalController,
  ViewController,
  AlertController
} from 'ionic-angular';
import {
  RealTimeService
} from '../../providers/real-time.service';
import {
  Subscription
} from "rxjs";
import {
  DatePipe,
  DecimalPipe
} from '@angular/common';
import * as L from 'leaflet';
import Polygon = L.Polygon;
import Marker = L.Marker;
import Icon = L.Icon;
import 'leaflet';
import {
  BehaviorSubject
} from 'rxjs/BehaviorSubject';
import {
  Content
} from 'ionic-angular';
import {
  GroupeRealtime
} from './group-realtime/group-realtime';
import { LoadingController } from 'ionic-angular/components/loading/loading-controller';

@Component({
  selector: 'page-groups-page',
  templateUrl: 'groups-page.html',
})
export class GroupsPage {
  @ViewChild(Content)
  content: Content;
  groupmodal: any;
  imageUri: string = "../../assets/icons/c1x0.png";
  allGroups: Subscription;
  public groups: any[] = [];
  selectedDevice: number;
  searchWord: string = "";
  allRealTimeRecords: Subscription;
  newRealTimeRecords: RealTimeRecord[] = null;
  oldRealTimeRecords: RealTimeRecord[] = null;
  angles: Map < number, number > = new Map();
  private realTimeRecordsItemSource = new BehaviorSubject < RealTimeRecord[] > ([]);
  data:any;
  imagescar = this.globalService.getimagescar();
  constructor(
    private alertCtrl: AlertController,
    public loading : LoadingController,
     public modalCtrl: ModalController,
      public navCtrl: NavController,
       private geocodingService: GeocodingService,
        private pipe: DecimalPipe,
         private dataManagementService: DataManagementService,
          public navParams: NavParams,
           public viewCtrl: ViewController,
            public realTimeService: RealTimeService,
            public mapService: MapService,
            public events: Events,
            private globalService : GlobalService) {
  }

  ngOnInit() {
    let date1 = new Date()

    console.log( date1.setHours(0,0,0,0));
   let loader= this.loading.create();
    loader.present();
    this.loadGroups();
    this.getAllRealTimeRecords();
    loader.dismiss();
    /*this.realTimeService.getGroupMini().subscribe(x => {
      this.groups = x;
      this.data=x;
      loader.dismiss();
    })*/
 
   /*    if(!this.groups)
      this.loadGroups();
     this.realTimeService.findVehiculesByGroupsId(15,1,0).subscribe(x=>{
        console.log(x);
      })*/
  }
  //selection group and go to group-realtime.ts
  selectedGroup(group: any) {
    this.groupmodal = this.modalCtrl.create(GroupeRealtime, {
      group
    });
    this.groupmodal.present();
    this.groupmodal.onDidDismiss(data => {
      if (data) {
        this.viewCtrl.dismiss(data);
      }
    });

  }
  //fermer modal
  closeModal() {
    this.viewCtrl.dismiss(null);
  }

  // ngAfterViewInit() {

  //   // this.content.ionScroll.subscribe(($event: any) => {
  //   //   let dimensions = this.content.getContentDimensions();
  //   //   let scrollHeight = dimensions.scrollHeight;
  //   //   let scrollTop = dimensions.scrollTop;
  //   //   let contentHeight = dimensions.contentHeight;
  //   //   let heightAndScrollTop = contentHeight + scrollTop;
  //   //   if((scrollHeight - heightAndScrollTop) <= 0 && (scrollHeight - heightAndScrollTop) >= 0) { 
  //   //     this.realTimeService.findVehiculesByGroupsId(15,1,0).subscribe(x=>{
  //   //       console.log(x);
  //   //     })
  //   //   }
  //   // });
  // }

  getItems(ev: any) {
    // Reset items back to all of the items
    this.groups=this.data;
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.groups = this.groups.filter((group) => {
        return (group.nom.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }


  goToRealTimeRecord(deviceId: Vehicule,isvalid:boolean){
    if(isvalid){

    let data={vehicule: deviceId ,groups:this.groups}
    this.viewCtrl.dismiss(data);
    }
  }
  loadGroups() {
    this.allGroups = this.realTimeService.getAllGroups(this.searchWord).subscribe(groupes => {
      this.groups = groupes;

      this.groups.forEach(group => {
        group.vehicules.forEach(vehicule => {
          console.log(vehicule.idDevice);
          vehicule.realTimeRecord=new RealTimeRecord();
          this.realTimeService.getRealTimeRecord(vehicule.idDevice).subscribe(x=>{

            vehicule.realTimeRecord = x;
            vehicule.realTimeRecord.vehicule=new RealTimeRecord();
            vehicule.realTimeRecord.vehicule=vehicule;
            this.trackRealTimeRecord(vehicule.realTimeRecord);
          },(err) => {

          });

        })
      });
    });
    this.getAllRealTimeRecords();
  }
  getAllRealTimeRecords() {
    this.allRealTimeRecords = this.realTimeService.getAllRealTimeRecords().subscribe(realTimeRecords => {
      this.realTimeRecordsItemSource.next(realTimeRecords);
      if (this.newRealTimeRecords) {
        this.oldRealTimeRecords = this.newRealTimeRecords;
      }
      this.newRealTimeRecords = realTimeRecords;
      realTimeRecords.forEach(realTimeRecord => {
        console.log(realTimeRecord)
        realTimeRecord.vehicule = this.getVehicule(realTimeRecord.idRealTimeRecord);

         this.trackRealTimeRecord(realTimeRecord);
        });
      });
    }
  getVehicule(idDevice: number): Vehicule {
    let foundVehicule = new Vehicule();
    for (let i = 0; i < this.groups.length; i++) {
      for (let j = 0; j < this.groups[i].vehicules.length; j++) {
        if (this.groups[i].vehicules[j].idDevice == idDevice) {
          foundVehicule = this.groups[i].vehicules[j];
          break;
        }
      }
    }
    return foundVehicule;
  }
    trackRealTimeRecord(realTimeRecord: RealTimeRecord) {
      let angle = 0;
      var date = new Date(realTimeRecord.recordTime);
      realTimeRecord.recordTime=new Date(new Date(realTimeRecord.recordTime).setHours(new Date(realTimeRecord.recordTime).getHours()-1));
      var minutes = date.getMinutes() + "";
      if (minutes.length == 1) {
        minutes = "0" + date.getMinutes();
      }
      let icon;
      let marker;
      let popup;
      if (!this.dataManagementService.pointInterests) {
        this.dataManagementService.getAllPointInterests().subscribe(pointInterests => {
          this.dataManagementService.pointInterests = pointInterests;
          realTimeRecord.relativePosition = this.dataManagementService.getRelativePosition(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng);
        })
      }
      else {
        realTimeRecord.relativePosition = this.dataManagementService.getRelativePosition(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng);
      }
      if (realTimeRecord.type === "AA") {
        angle = realTimeRecord.rotationAngle * 8;
      }
      if (this.oldRealTimeRecords && realTimeRecord.type === "GPRMC") {
        let oldRealTimeRecord = this.getOldRealTimeRecord(realTimeRecord.idRealTimeRecord);
        if (oldRealTimeRecord) {
          if (!this.compareTwoCoordinate(oldRealTimeRecord.coordinate, realTimeRecord.coordinate)) {
            angle = Math.atan2(realTimeRecord.coordinate.lng - oldRealTimeRecord.coordinate.lng, realTimeRecord.coordinate.lat - oldRealTimeRecord.coordinate.lat) * 180 / Math.PI;
            this.angles.set(realTimeRecord.idRealTimeRecord, angle);
          } else {
            angle = this.angles.get(realTimeRecord.idRealTimeRecord);
          }
        }
      }
      popup = '<b>Chauffeur:</b> ' + this.dataManagementService.getDriverName(realTimeRecord.vehicule.driver) +
      '<br><b>Matricule:</b> ' + realTimeRecord.vehicule.matricule +
      '<br><b>Mark:</b> ' + realTimeRecord.vehicule.mark +
      '<br><b>Lat,Lng:</b><i> [' + this.PipeLngLat(realTimeRecord.coordinate.lat) + ',' + this.PipeLngLat(realTimeRecord.coordinate.lng) + ']</i><br><b>Vitesse :</b>' + realTimeRecord.speed +
      "<br><b>date et l'heure:</b> " + (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + minutes +
      "<br><b>Signal GSM:</b> " + realTimeRecord.signal +
      " <i class='fa fa-wifi' aria-hidden='true'></i><br><b>Sat en vue:</b> " + realTimeRecord.satInView + " <i class='fa fa-globe' aria-hidden='true'></i>";

  
      

    //this.imageUri:string = "/images/c1x0.png";

      if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed == 0 && realTimeRecord.ignition== true) {
        icon =  L.icon({
          iconUrl: this.imagescar + "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -10],
          iconSize:     [35, 35] 
        });
        this.imageUri = this.imagescar+ "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
      }
      if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed > 0 ) {
        icon =  L.icon({
          iconUrl: this.imagescar + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25],
          iconSize:     [35, 35]
        });
        this.imageUri = this.imagescar + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
      }
      if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed == 0 && realTimeRecord.ignition== false) {
        icon = L.icon({
          iconUrl: this.imagescar + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25],
          iconSize:     [35, 35] 
        });
        this.imageUri = this.imagescar + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
      }
      if (realTimeRecord.realTimeRecordStatus == 'NON_VALID' || realTimeRecord.realTimeRecordStatus == 'TECHNICAL_ISSUE') {
        icon = L.icon({
          iconUrl: this.imagescar + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
          iconAnchor: [-2, 30],
          popupAnchor: [10, -25],
          iconSize:     [35, 35] 
        });
        this.imageUri = this.imagescar + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
      }
      marker = new Marker(realTimeRecord.coordinate, {
        rotationAngle: angle,
        icon : icon
      });
      realTimeRecord.icon = this.imageUri;
      let markerGroup = L.featureGroup();
      markerGroup.addLayer(marker);
      marker.bindPopup(popup);
     

      this.mapService.map.addLayer(markerGroup).on('click', ()=> {
      this.events.publish('Showinfo', true)
      });;

      this.geocodingService.inverseGeoconding(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng, 18).subscribe(adress => {
        realTimeRecord.geocoding = this.getGeocoding(adress.address);
        realTimeRecord.geocodingDetails = adress.display_name;
        this.updateSpecificGroups(realTimeRecord);


      },(err) => {

      });

    }
    getOldRealTimeRecord(id: number): RealTimeRecord {
      let result = this.oldRealTimeRecords.filter(rt => {
        return rt.idRealTimeRecord == id;
      });
      if (result) return result[0];
      else return null;
    }
    compareTwoCoordinate(p1, p2) {
      if (p1.lat == p2.lat && p1.lng == p2.lng) return true;
      else false;
    }
    PipeLngLat(value: any) {
      return this.pipe.transform(value, '2.2-6');
    }
    getGeocoding(address: any): string {
      let geocoding: string = null;
      if (address) {
        if (address.road != null) {
          geocoding = address.road;
        }
        if (address.neighbourhood != null) {
          geocoding = geocoding ? geocoding + ' ' + address.neighbourhood : address.neighbourhood;
        }
        if (address.city != null) {
          geocoding = geocoding ? geocoding + ' (' + address.city + ')' : address.city;
        }
        if (geocoding == null) {
          geocoding = 'chargement..';
        }
      }
      return geocoding;
    }
    updateSpecificGroups(realTimeRecord: RealTimeRecord) {
      if (this.groups)
        this.groups.forEach(group => {
          if (group)
            group.vehicules.forEach(vehicule => {
              if (vehicule.idDevice == realTimeRecord.idRealTimeRecord)
                vehicule.realTimeRecord = realTimeRecord;
            })
        })
    }
      isValidPoint(point: {lat: number,lng: number}) {
         if (point && point.lng !== 0 && point.lng !== 0)return true;
        else return false;
     }
 
}



// WEBPACK FOOTER //
// ./src/pages/groups-page/groups-page.ts